import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgUbereat = function SvgUbereat(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#ubereat_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-.48-.48h35.96v35.96H-.48V-.48Zm17.372 22.992a1.515 1.515 0 1 0-1.532 1.499h.016a1.495 1.495 0 0 0 1.516-1.473v-.026Zm1.238-2.453v4.906h-1.261v-.445c-.45.37-1.015.572-1.597.568-1.492 0-2.66-1.146-2.66-2.578 0-1.431 1.168-2.577 2.66-2.577a2.487 2.487 0 0 1 1.597.568v-.445l1.26.003Zm4.191 3.793h-.948c-.289 0-.474-.125-.474-.386v-2.294h1.422V20.06H20.9v-1.396h-1.272v1.396h-.96v1.113h.96v2.612c0 .658.474 1.18 1.33 1.18h1.364v-1.112Zm2.875 1.238c1.457 0 2.278-.682 2.278-1.624 0-.67-.485-1.17-1.503-1.386l-1.076-.215c-.624-.113-.821-.227-.821-.454 0-.297.3-.477.856-.477.601 0 1.04.159 1.168.704h1.26c-.069-1.022-.82-1.704-2.347-1.704-1.319 0-2.244.534-2.244 1.568 0 .715.509 1.18 1.608 1.407l1.203.273c.474.09.6.216.6.41 0 .305-.358.498-.937.498-.728 0-1.145-.159-1.307-.704h-1.271c.185 1.022.96 1.704 2.533 1.704Zm-17.67-6.768h4.754v1.136H8.81v1.623h3.377v1.102H8.809v1.646h3.47v1.136H7.527v-6.643Zm19.892-6.647v.893h-.406c-.639 0-1.102.485-1.102 1.234v2.751h-.977v-4.839h.967v.596c.241-.389.636-.636 1.18-.636h.338Zm-5.51.779c-.725 0-1.334.493-1.508 1.234h3.006c-.165-.74-.773-1.234-1.498-1.234Zm-2.514 1.657a2.512 2.512 0 0 1 2.533-2.492h-.002c1.421 0 2.465 1.073 2.465 2.515v.313h-4.012a1.644 1.644 0 0 0 1.634 1.376c.57 0 1.054-.228 1.421-.712l.708.513c-.493.645-1.228 1.034-2.127 1.034-1.479 0-2.62-1.082-2.62-2.524v-.023Zm-4.71.02a1.678 1.678 0 0 0 1.666 1.69h.002a1.678 1.678 0 1 0-1.668-1.691Zm-.026 2.421h-.967V9.91h.977v2.42a2.459 2.459 0 0 1 1.75-.722c1.45 0 2.59 1.13 2.59 2.534 0 1.395-1.14 2.524-2.59 2.524a2.485 2.485 0 0 1-1.76-.721v.607Zm-2.736-2.543c0 1.053-.724 1.765-1.662 1.765-.948 0-1.663-.692-1.663-1.765V9.911H7.582v4.157c0 1.565 1.112 2.6 2.562 2.6.705 0 1.334-.266 1.788-.731v.617h1.005V9.91h-1.015v4.098Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "ubereat_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgUbereat;